<template>
	<div >
	<el-card :body-style="{ padding: '0px' }" :shadow="shadow" style="padding:5px">

		<div class="card-info">
			<el-row >
				<el-container>
				 <el-main class="contact-fiche-info">
				 	<el-row >
				 		<el-col>
				 			<el-button type="text" @click="openClient()"><span class="client-name client-info">{{name}} <i class="mdi mdi-link-variant"/></span></el-button>
				 		</el-col>
				 	</el-row>
				 	<el-row v-if="this.hasRole" >
				 		<el-col>
				 			<span class="client-info secondary-text fs-14">{{company.role.code}}</span>
				 		</el-col>
				 	</el-row>
				 	<el-row v-if="company.active">
				 		<el-col>
							<!-- <div style="height:100%:float:left;width:25px;"><i class="mdi mdi-email-outline"></i></div> -->
							<!-- <div style="height:100%float:left;"> -->
					 			<span class="client-info secondary-text fs-14" v-if="getEmail">{{getEmail}}</span>
								<span class="client-info no-info secondary-text fs-14" v-if="getEmail==null">{{ $t('common.notAvailable') }}</span>
							<!-- </div> -->
				 		</el-col>
				 	</el-row>
				 	<el-row v-if="company.active">
				 		<el-col>
				 			<!-- <i class="mdi mdi-phone"></i> -->
							<span class="client-info secondary-text fs-14" v-if="getPhone">{{getPhone}}</span>
							<span class="client-info no-info secondary-text fs-14" v-else>{{ $t('common.notAvailable') }}</span>
				 		</el-col>
				 	</el-row>
				 </el-main>
				</el-container>
			</el-row>
		</div>
	</el-card>
</div>
</template>

<script>

export default {
	name: 'ContactCompanyCard',
	props : {
		company : {
			type : Object,
		},
		shadow : {
			type : String,
		}
	},
	components : {

	},
	computed : {
		isHover(){
			if(this.editable){
				return "hover";
			}
		},
		isHover(){
			return this.shadow=='hover';
		},
		name(){
			return this.company.name;
		},
		hasRole(){
			return (this.company.role!=null && this.company.role.code!=null);
		},
		getPhone(){
			return this.company.work_phone;

		},
		getEmail(){
				return this.company.work_email;
		},

	},
	methods: {
		openClient(){
			// if(this.shadow=='hover'){
				var index = '/customers/' + this.company.customer.id;
				this.$router.push(index)
				this.$emit('push-page', {page:index})
			// }
		}
	}

}
</script>

<style lang="scss" scoped>

.small{
	font-size:10pt;
	height:120px;
}
.hide{
	display:none;
}
.contact-fiche-info{
	padding-left:10px!important;
}
.client-info{
 	margin:5px;
 }

 .no-info{
	 font-size:12px;
 }
.client-name{
  	font-size:1.7 em;
  	color:#4a596a;
  }

.card-info{
	margin:10px;
	color:#a9aaad;
	margin-bottom:10px;
	//padding-right:120px;
}
.el-row{
	margin-bottom:5px;
}

.remove-control{
	position: absolute;
    top: 10px;
    float: right;
    right: 20px;
	color:#9AA2AC;

}
.remove-control:hover{
	cursor:pointer;
	color:#4a596a;
}

.edit-control{
	position: absolute;
    top: 10px;
    float: right;
    right: 40px;
	color:#9AA2AC;

}
.edit-control:hover{
	cursor:pointer;
	color:#4a596a;
}

.el-main {
	padding:0px;
}

.contactClickable{
	cursor:pointer;
}



@media (max-width: 768px) {
	.card-info{
		margin:0px;
		color:#a9aaad;
		margin-bottom:10px;
		//padding-right:120px;
	}
}
</style>
